import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';

import Datatable, { RELOAD_TABLE_TIME } from '../../components/Datatable/';

import {
  getAllProducts,
  removeProducts,
  restoreProducts
} from '../../redux/actions/products';
import TableHeader from '../../components/TableHeader';
import ModalRemoveItem from '../../components/ModalRemoveItem';
import ModalRestoreItem from '../../components/ModalRestoreItem';
import searchForPermissions from '../../utils/searchForPermissions';
// import formatCurrencyString from '../../utils/formatCurrencyString';
// import calcProfitPercentage from '../../utils/calcProfitPercentage';
// import origins from '../../utils/origins';
// import itensTypes from '../../utils/itensTypes';

function List (props) {
  const products = useSelector(state => state.products);
  const dispatch = useDispatch();
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const currentPermissions = searchForPermissions(
    'submenu',
    props.match.path,
    sessionUser.permissionsGroup.permissions
  );
  const [showTable, setShowTable] = useState(true);
  useEffect(() => {
    if (showTable) {
      setShowTable(false);
      setTimeout(() => setShowTable(true), RELOAD_TABLE_TIME);
    }
  }, [currentPermissions.options]);
  const tableData = products.data.filter(
    item => item.active || currentPermissions.options.r
  );
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [idItemWillRemove, setIdItemWillRemove] = useState('');
  const [nameItemWillRemove, setNameItemWillRemove] = useState('');
  const handleModalConfirmYesRemove = id => {
    setShowModalRemove(false);
    dispatch(removeProducts(id));
  };
  const [showModalRestore, setShowModalRestore] = useState(false);
  const [idItemWillRestore, setIdItemWillRestore] = useState('');
  const [nameItemWillRestore, setNameItemWillRestore] = useState('');
  const handleModalConfirmYesRestore = id => {
    setShowModalRestore(false);
    dispatch(restoreProducts({ _id: id, active: true }));
  };
  const urlRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._/+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_/+.~#?&/=]*)$/;

  useEffect(() => {
    dispatch(getAllProducts({ company }));
  }, [dispatch]);

  const columns = [
    {
      title: 'SKU',
      data: 'sku',
      render: data => data || '---'
    },
    {
      title: 'Nome',
      data: 'name',
      render: data => data || '---'
    },
    {
      title: 'Modelo',
      data: 'model',
      render: data => data || '---'
    },
    {
      title: 'Fabricante',
      data: 'manufacturer.name',
      render: data => data || '---'
    },
    {
      title: 'Fornecedor',
      data: 'supplier.name',
      render: data => data || '---'
    },
    {
      title: 'Preço de Compra',
      data: 'purchasePrice',
      render: (data, type) => {
        if (data) {
          if (type === 'display' || type === 'filter') {
            return parseInt(data).toFixed(2) || 0.0;
          } else {
            return parseInt(data).toFixed(2);
          }
        } else {
          return 0.0;
        }
      }
    },
    {
      title: 'Estoque',
      data: 'stockQuantity',
      render: (data, type) => {
        if (data) {
          if (type === 'display' || type === 'filter') {
            return parseInt(data) || 0;
          } else {
            return parseInt(data);
          }
        } else {
          return 0;
        }
      }
    },
    // {
    //   title: 'Preço de Varejo',
    //   data: 'retailSaleValue',
    //   render: data => (String(data) ? formatCurrencyString(data) : '---')
    // },
    // {
    //   title: 'Lucro do Varejo',
    //   data: 'retailProfit',
    //   render: (data, _, obj) => {
    //     return String(data)
    //       ? formatCurrencyString(obj.retailSaleValue - obj.purchasePrice)
    //       : '---';
    //   }
    // },
    // {
    //   title: 'Margem de Varejo',
    //   data: 'retailMargin',
    //   render: (data, _, obj) => {
    //     return String(data)
    //       ? `${calcProfitPercentage(
    //           String(obj.purchasePrice),
    //           String(obj.retailSaleValue)
    //         )}%`
    //       : '---';
    //   }
    // },
    // {
    //   title: 'Preço de Atacado',
    //   data: 'wholeSaleValue',
    //   render: data => (String(data) ? formatCurrencyString(data) : '---')
    // },
    // {
    //   title: 'Lucro do Atacado',
    //   data: 'wholeSaleProfit',
    //   render: (data, _, obj) => {
    //     return String(data)
    //       ? formatCurrencyString(obj.wholeSaleValue - obj.purchasePrice)
    //       : '---';
    //   }
    // },
    // {
    //   title: 'Margem de Atacado',
    //   data: 'wholeSaleValueMargin',
    //   render: (data, _, obj) => {
    //     return String(data)
    //       ? `${calcProfitPercentage(
    //           String(obj.purchasePrice),
    //           String(obj.wholeSaleValue)
    //         )}%`
    //       : '---';
    //   }
    // },
    // {
    //   title: 'Quantidade Mín. de Peças Vendas no Atacado',
    //   data: 'wholesaleMinQuantity',
    //   render: data => data || '---'
    // },
    // {
    //   title: 'R$ Lucro Aprox. MarketPlaces Taxa de 26%',
    //   data: 'approximateProfitMarketPlacesValue',
    //   render: (data, _, obj) => {
    //     return String(data)
    //       ? formatCurrencyString(
    //         obj.retailSaleValue -
    //             (obj.retailSaleValue * 0.26 + obj.purchasePrice)
    //       )
    //       : '---';
    //   }
    // },
    // {
    //   title: '% Lucro Aprox. MarketPlaces Taxa de 26%',
    //   data: 'approximateProfitMarketPlacesPercent',
    //   render: (data, _, obj) => {
    //     if (obj.retailSaleValue && obj.purchasePrice) {
    //       const cust = obj.retailSaleValue * 0.26 + obj.purchasePrice;
    //       const profit = obj.retailSaleValue - cust;
    //       const result = (profit / cust) * 100;
    //       return `${result.toFixed(1)}%`;
    //     } else {
    //       return '---';
    //     }
    //   }
    // },
    // {
    //   title: 'Status',
    //   data: 'status',
    //   render: data => (data ? 'Ativo' : 'Inativo')
    // },
    // {
    //   title: 'Condição',
    //   data: 'condition',
    //   render: data => (data === 'NEW' ? 'Novo' : 'Usado')
    // },
    // {
    //   title: 'Localização Estoque',
    //   data: 'location',
    //   render: data => data || '---'
    // },
    // {
    //   title: 'DropShipping',
    //   data: 'enabledDropshipping',
    //   render: data => (data ? 'Ativo' : 'Inativo')
    // },
    // {
    //   title: 'Preço de DropShipping',
    //   data: 'dropshippingValue',
    //   render: data => (String(data) ? formatCurrencyString(data) : '---')
    // },
    // {
    //   title: 'Margem de DropShipping',
    //   data: 'dropshippingValueMargin',
    //   render: (data, _, obj) => {
    //     return String(data)
    //       ? `${calcProfitPercentage(
    //           String(obj.purchasePrice),
    //           String(obj.dropshippingValue)
    //         )}%`
    //       : '---';
    //   }
    // },
    // {
    //   title: 'Quantidade Mín. de Peças Vendas no DropShipping',
    //   data: 'minDropshippingQuantity',
    //   render: data => data || '---'
    // },
    // {
    //   title: 'Peso (Kg)',
    //   data: 'weight',
    //   render: data => (String(data) ? `${data.toFixed(2)} Kg` : '---')
    // },
    // {
    //   title: 'Comprimento (cm)',
    //   data: 'length',
    //   render: data => (String(data) ? `${data.toFixed(2)} cm` : '---')
    // },
    // {
    //   title: 'Largura (cm)',
    //   data: 'width',
    //   render: data => (String(data) ? `${data.toFixed(2)} cm` : '---')
    // },
    // {
    //   title: 'Altura (cm)',
    //   data: 'height',
    //   render: data => (String(data) ? `${data.toFixed(2)} cm` : '---')
    // },
    {
      title: 'EAN (GTIN)',
      data: 'ean',
      render: data => data || '---'
    },
    {
      title: 'NCM',
      data: 'ncm',
      render: data => data || '---'
    },
    // {
    //   title: 'CEST',
    //   data: 'cest',
    //   render: data => data || '---'
    // },
    // {
    //   title: 'CSOSN',
    //   data: 'csosn',
    //   render: data => data || '---'
    // },
    // {
    //   title: 'CFOP (Mesmo Estado)',
    //   data: 'cfopSameState',
    //   render: data => data || '---'
    // },
    // {
    //   title: 'CFOP (Outro Estado)',
    //   data: 'cfopAnotherState',
    //   render: data => data || '---'
    // },
    // {
    //   title: 'Origem',
    //   data: 'origin',
    //   render: data => {
    //     return `${data} - ${origins[data]}`;
    //   }
    // },
    // {
    //   title: 'Tipo de Item',
    //   data: 'itemType',
    //   render: data => {
    //     return `${data} - ${itensTypes[data]}`;
    //   }
    // },
    {
      title: 'Ações',
      data: '_id',
      orderable: false,
      className: 'no-export',
      render: (data, type, obj) => {
        return `
          <div class="btn-group">
          ${`<a href="${
            obj.link
          }" target="_blank" rel="noopener noreferrer"><button id="${data}" ${!urlRegex.test(
            obj.link
          ) &&
            'disabled=""'} type="button" title="Acessar Arquivos Adicionais" class="btn btn-dark button-action rounded"><i class="fa fa-folder-open"></i></button></a>`}
          ${
            !(currentPermissions.options.l && currentPermissions.options.u)
              ? ''
              : `<button id="${data}" type="button" title="Editar" class="btn btn-warning button-action button-action-update rounded"><i class="fa fa-edit"></i></button>`
          }
          ${
            !obj.active ||
            !(currentPermissions.options.l && currentPermissions.options.d)
              ? ''
              : `<button id="${data}" type="button" title="Excluir" class="btn btn-danger button-action button-action-delete m-1 rounded"><i class="fa fa-trash"></i></button>`
          }
          ${
            obj.active ||
            !(currentPermissions.options.l && currentPermissions.options.r)
              ? ''
              : `<button id="${data}" type="button" title="Restaurar" class="btn btn-info button-action button-action-restore m-1 rounded"><i class="fas fa-trash-restore-alt"></i></button>`
          }
          </div>`;
      }
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  const handleUpdateButton = id => {
    const url = '/products/edit/' + id;
    dispatch(push(url));
  };

  const handleDeleteButton = dataRow => {
    setNameItemWillRemove(dataRow.name);
    setIdItemWillRemove(dataRow._id);
    setShowModalRemove(true);
  };

  const handleRestoreButton = dataRow => {
    setNameItemWillRestore(dataRow.name);
    setIdItemWillRestore(dataRow._id);
    setShowModalRestore(true);
  };

  return (
    <div className="container-fluid">
      <ModalRemoveItem
        showModal={showModalRemove}
        handleModalClose={() => setShowModalRemove(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRemove(idItemWillRemove)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja excluir o produto'}
        nameItemWillRemove={nameItemWillRemove}
      />
      <ModalRestoreItem
        showModal={showModalRestore}
        handleModalClose={() => setShowModalRestore(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRestore(idItemWillRestore)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja restaurar o produto'}
        nameItemWillRestore={nameItemWillRestore}
      />
      <TableHeader
        title={'Produtos'}
        url={'/products/add'}
        updateList={() => dispatch(getAllProducts({ company }))}
        isFetching={products.isFetching}
        hideAddButton={!currentPermissions.options.c}
        hideUpdateButton={!currentPermissions.options.l}
      />
      {showTable && currentPermissions.options.l && (
        <Datatable
          data={tableData}
          columns={columns}
          buttons={buttons}
          handleUpdateButton={handleUpdateButton}
          handleDeleteButton={handleDeleteButton}
          handleRestoreButton={handleRestoreButton}
        />
      )}
    </div>
  );
}

List.propTypes = {
  match: PropTypes.object
};

export default List;
